import AbstractColumn from "./AbstractColumn.js";

/**
 * Group of columns.
 *
 * @param {Renderable} [title] - Title of the group. If none is provided, the
 *   sub-columns will render without showing they are part of a group
 * @param {AbstractColumn[]} columns - Columns of the group
 */
export default class GroupColumn extends AbstractColumn {
	constructor({ columns }) {
		super(...arguments);

		this._columns = columns;
	}

	getLeaves() {
		if (!this._columns.length) return [];

		return this._columns.reduce((result, column) => {
			result.push(...column.getLeaves());
			return result;
		}, []);
	}

	getSerializableLeaves() {
		return this._columns.flatMap((column) =>
			column.getSerializableLeaves(),
		);
	}

	setReport(...args) {
		super.setReport(...args);

		for (const column of this._columns) {
			column.setReport(...args);
		}
	}

	setDataForRow({ row, data }) {
		if (!data) {
			return;
		}

		this._columns.forEach((child, index) => {
			child.setDataForRow({ row, data: data[index] });
		});
	}

	getColumns() {
		return this._columns;
	}

	hasData() {
		return this._columns.some((column) => column.hasData());
	}

	accept(visitor) {
		return visitor.visitGroupColumn(this);
	}

	_getDefaultTitle() {
		return this._title;
	}

	static getType() {
		return "GroupColumn";
	}
}
